
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
    name: 'BaseIcon',
})
export default class BaseIcon extends Vue {
    @Prop({ required: true }) name!: string

    get normalizedName() {
        return this.name.replaceAll('_', '-')
    }
}
